import {useEffect} from 'react';

import {Box, Grid} from '@mui/material';
import PropTypes from 'prop-types';
import {useFormContext} from 'react-hook-form';

import useEmmai from '../../../../../hooks/providers/useEmmai';
import {practitionerActivityLeftFields as leftFields, practitionerActivityRightFields as rightFields} from '../../../forms-utils/form-schemas/practitioner-activity';
import {renderFormFields} from '../../../forms-utils/renderFormFields';

const EmmaiPractitionerActivityInformationForm = ({practitionerId}) => {
  const {
    formState: {isDirty},
    control
  } = useFormContext();

  const {setPendingDate, registerBeforeDateChange, setWarningActivityDataWillBeLostOnMonthChangeModalOpen} = useEmmai();
  const formPrefixName = `practitionerActivity.${practitionerId}`;

  useEffect(() => {
    registerBeforeDateChange(async newDate => {
      if (!isDirty) return true;
      setWarningActivityDataWillBeLostOnMonthChangeModalOpen(true);
      setPendingDate(newDate);
    });
  }, [isDirty, registerBeforeDateChange, setPendingDate, setWarningActivityDataWillBeLostOnMonthChangeModalOpen]);

  return (
    <Box>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          {renderFormFields(formPrefixName, leftFields, control)}
        </Grid>

        <Grid item xs={12} sm={6}>
          {renderFormFields(formPrefixName, rightFields, control)}
        </Grid>
      </Grid>
    </Box>
  );
};

EmmaiPractitionerActivityInformationForm.propTypes = {
  practitionerId: PropTypes.string.isRequired
};

export default EmmaiPractitionerActivityInformationForm;
